import { AnyAction } from "redux";
import { State } from "../props/State.props";
import { THEME, FONT_FAMILY, RESUME_DATA } from "./actions";

export const getData: State["getResumeData"] = {
  dp: "data:image/png;base64,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",
  name: "Your Name",
  position: "Your Position",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam neque ligula, laoreet condimentum lacus nec, fermentum condimentum sapien. Vivamus eget libero pulvinar, scelerisque mauris sed, bibendum ipsum",
  email: "example@domain.com",
  ph_no: "1234567890",
  location: "City, Country",
  linkedin: "linkedin.com/in/username",
  lsLayout: [
    {
      title: "Education",
      type: "ed",
      record: [
        {
          degree: "Degree",
          university: "University",
          date: "MM/DD/YYYY",
        },
      ],
    },
    {
      title: "Work Experience",
      type: "exp",
      record: [
        {
          role: "Position",
          company: "Company",
          location: "City, Country",
          date: "MM/DD/YYYY",
          responsibilities: [
            "Responsibility 1",
            "Responsibility 2",
            "Responsibility 3",
          ],
        },
      ],
    },
    {
      title: "Languages",
      type: "lang",
      record: [
        {
          lang: "Language",
          rate: 2,
        },
      ],
    },
  ],
  rsLayout: [
    {
      title: "Skills",
      type: "skill",
      record: { skills: ["Skill 1", "Skill 2", "Skill 3"] },
    },
    {
      title: "Certificates",
      type: "cert",
      record: {
        certifications: [
          "Certificate 1",
          "Certificate 2",
          "Certificate 3",
          "Certificate 4",
        ],
      },
    },
  ],
};

const initialState = {
  getTheme: "light",
  getFontFamily: "Montserrat",
  getResumeData: getData,
};

export default function Reducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case THEME:
      return { ...state, getTheme: action.payload };
    case FONT_FAMILY:
      return { ...state, getFontFamily: action.payload };
    case RESUME_DATA:
      return { ...state, getResumeData: action.payload };
    default:
      return state;
  }
}
